import { User, UserManager, UserManagerSettings } from 'oidc-client-ts';
import {
  IDENTITY_AUTHORITY,
  IDENTITY_CLIENT_ID,
  IDENTITY_REDIRECT_URI,
  IDENTITY_SCOPE,
  IDENTITY_LOGOUT_REDIRECT_URI,
  IDENTITY_SILENT_REDIRECT_URI,
  IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME,
} from '../constants/authConstants';
import { ROUTE_HOMEPAGE } from '../constants/urlConstants';
import { removeRedirectUrl, removeUser, setUser } from '../utils/auth';
import { httpServices } from './httpServices';
import { useAuthStore } from '../stores/useAuthStore';

const { setAuthHeader } = httpServices;

const IDENTITY_CONFIG: UserManagerSettings = {
  authority: IDENTITY_AUTHORITY ? IDENTITY_AUTHORITY : '',
  client_id: IDENTITY_CLIENT_ID ? IDENTITY_CLIENT_ID : '',
  redirect_uri: IDENTITY_REDIRECT_URI ? IDENTITY_REDIRECT_URI : '',
  response_type: 'code',
  scope: IDENTITY_SCOPE,
  post_logout_redirect_uri: IDENTITY_LOGOUT_REDIRECT_URI,
  // Controle da renovação de token automática
  automaticSilentRenew: false,
  silent_redirect_uri: IDENTITY_SILENT_REDIRECT_URI,
  // Tempo (em segundos) antes do token expirar para notificar o usuário
  accessTokenExpiringNotificationTimeInSeconds:
    IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME,
};

export const userManager = new UserManager(IDENTITY_CONFIG);

// export const getIdentityAcessTokenExpiringTime = tokenExpireTimeLeft => tokenExpireTimeLeft;

export async function loadUserFromStorage() {
  try {
    const user = await userManager.getUser();

    if (!user) {
      return setUser(null);
    }

    // getIdentityAcessTokenExpiringTime(user.expires_in);

    // Salva token no header para cada requisição
    setAuthHeader(user?.access_token);

    // Restringe dados do usuário a serem guardados
    const userData = {
      token: user.access_token,
      fullname: `${user.profile.given_name || ''} ${user.profile.family_name || ''}`,
      email: user.profile.name,
      roles: user.profile.role,
      // expire: user.expires_in, // Tempo até o token expirar
    };

    return setUser(userData);
  } catch (e) {
    console.error(`User not found: ${e}`);
    setUser(null);
  }
}

export const signinRedirect = () => userManager.signinRedirect();

export const signinRedirectCallback = () =>
  userManager.signinRedirectCallback();

export const signoutWithoutRedirect = () => {
  userManager.getUser().then(() => {
    userManager.clearStaleState();
    userManager.removeUser();
    setAuthHeader(null);
    removeUser();
    removeRedirectUrl();
    return;
  });
};

export const signoutRedirect = (redirect = false) => {
  userManager.getUser().then((user) => {
    userManager.clearStaleState();
    userManager.removeUser();

    setAuthHeader(null);
    removeUser();
    removeRedirectUrl();

    if (redirect) {
      window.location.href = `${process.env.NEXT_PUBLIC_BASE_SITE_URL_SP_VITE}/signout-oidc/?logout=true`;
    }

    return userManager.signoutRedirect({ id_token_hint: user?.id_token });
  });
};

export const signoutRedirectCallback = async () => {
  userManager.getUser().then(() => {
    userManager.clearStaleState();
    userManager.removeUser();
    return userManager.signoutRedirectCallback(ROUTE_HOMEPAGE);
  });
};

export const signinSilent = async () => {
  try {
    const user = await userManager.signinSilent();

    if (user) {
      setAuthHeader(user.access_token);
      await loadUserFromStorage();
      return user;
    }

    await signinRedirect();
    return null;
  } catch (error) {
    console.error(error);
    await signinRedirect();
    return null;
  }
};

export const signinSilentCallback = () => userManager.signinSilentCallback();

export const DoCheckTokenExpiration = async () => {
  const { setOpenModalTimeout } = useAuthStore();

  try {
    const user: User | null = await userManager.getUser();

    if (user && user.expires_at) {
      const currentTime = Math.floor(Date.now() / 1000); // Tempo atual em segundos
      const hasValidExpirationTimeToken =
        user.expires_at - currentTime <= 60 &&
        user.expires_at - currentTime > 0;

      // Verifica se o token está próximo de expirar (por exemplo, 1 minuto antes)
      if (hasValidExpirationTimeToken) {
        await signinSilent(); // Renova o token silenciosamente
      } else if (user.expires_at - currentTime < 0) {
        setOpenModalTimeout(true);
      } else {
        console.log('');
      }
    } else {
      console.log('');
    }
  } catch (error) {
    console.error(error);
  }
};

// // Chame a função DoCheckTokenExpiration em intervalos para verificar a expiração do token
// setInterval(DoCheckTokenExpiration, 1 * 60 * 1000)
